export default __webpack_public_path__ + "static/pro@992-ff736559656be262270bcf2c5a623dc4.webp";